import type { TOC } from '@ember/component/template-only';
import { PrismBadge } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import { PMS_TABLE_ROW_TYPES } from 'lumen/utils/constants/channel-pricing-constants';

import styles from './td-pms-table-name-cell.module.css';

interface HotelChannelPricingTablesCellsPmsTableTdPmsTableNameCellSignature {
  Args: {
    row: {
      type: (typeof PMS_TABLE_ROW_TYPES)[keyof typeof PMS_TABLE_ROW_TYPES];
    };
    value: string;
  };
}

const HotelChannelPricingTablesCellsPmsTableTdPmsTableNameCell: TOC<HotelChannelPricingTablesCellsPmsTableTdPmsTableNameCellSignature> =
  <template>
    <div
      class="text-200--medium flex flex-row items-center ic-product-tour-49521458-sd-pms-table-row-name-{{@row.type}}
        ic-product-tour-55124760-sd-pms-table-row-name-{{@row.type}}"
      data-test-id="pms-table-name-cell"
    >
      <p class="truncate" title={{@value}}>
        {{@value}}
      </p>

      {{#if (eq @row.type PMS_TABLE_ROW_TYPES.PRICING_PARENT_ROW)}}
        <div class={{styles.badge}}>
          <PrismBadge
            @badgeType="neutral"
            @isSmallBadge={{true}}
            @label={{t "channel_pricing.table_name_cell.leading_room"}}
          />
        </div>
      {{/if}}
    </div>
  </template>;

export default HotelChannelPricingTablesCellsPmsTableTdPmsTableNameCell;
